<template>
  <div class="demand">
    <div class="mainContent">
      <div class="moduleTitle">
        {{ mainTitle ? mainTitle : "根据需求，选择最适合您的套餐" }}
      </div>
      <div class="demandBox flex justify-center items-baseline" >
        <div v-for="(item, idx) in dataArr" :key="idx" style="margin-left: 20px">
          <div
            class="titleArea"
            :style="{
              backgroundImage: 'url(' + item.titleBg + ')',
            }"
          >
            <div class="title">{{ item.title }}</div>
            <div class="titleDesc">{{ item.titleDesc }}</div>
          </div>
          <div class="mainArea">
            <div v-for="(tc, j) in item.tcList" :key="'tc_' + j">
              <div class="tcName">{{ tc.tcName }}</div>
              <div class="countArea flex items-baseline">
                <div class="unit">￥</div>
                <div class="count">
                  {{ tc.count }}
                </div>
                <div class="countDesc">
                  {{ tc.countDesc }}
                </div>
              </div>
              <div
                v-for="(f, fi) in tc.featureList"
                :key="'f_' + fi"
                class="flex items-center featureBox"
              >
                <img :src="f.support ? support : notSupport" alt="" />
                <div>{{ f.name }}</div>
              </div>
            </div>
            <!-- <div class="text-center" v-if="item.canTest">
              <div
                class="testBtn"
                @click="freeTest"
                
              >
                免费测试
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bzPng from "@/assets/imgs/home/demand/bz.png";
import gjPng from "@/assets/imgs/home/demand/gj.png";
import hhPng from "@/assets/imgs/home/demand/hh.png";
import support from "@/assets/imgs/home/demand/support.png";
import notSupport from "@/assets/imgs/home/demand/notSupport.png";
export default {
  props: {
    mainTitle: String,
  },
  data() {
    return {
      support,
      notSupport,
      dataArr: [
        {
          title: "免费用户",
          titleDesc: "仅可使用部分功能",
          titleBg: bzPng,
          tcList: [
            {
              tcName: "免费用户",
              count: "0",
              countDesc: "",
              featureList: [
                {
                  name: "一键发送",
                  support: true,
                },
                {
                  name: "批量发送",
                  support: true,
                },
                {
                  name: "批量选择",
                  support: true,
                },
                {
                  name: "批量排序",
                  support: true,
                },
                {
                  name: "书签模式",
                  support: true,
                },
                {
                  name: "多色标签",
                  support: true,
                },
                {
                  name: "自定义热键",
                  support: true,
                },
                {
                  name: "短语储存量（200条）",
                  support: true,
                },
                {
                  name: "翻译功能（字符另行付费）",
                  support: true,
                },
                {
                  name: "图文储存、发送",
                  support: false,
                },
                {
                  name: "Excel导入导出",
                  support: false,
                },
                {
                  name: "7天数据云备份",
                  support: false,
                },
                {
                  name: "7天数据手动备份",
                  support: false,
                },
                {
                  name: "大图预览",
                  support: false,
                },
              ],
            },
          ],
          canTest: false,
        },
        {
          title: "一年期会员",
          titleDesc: "会员期限内可使用所有功能",
          titleBg: gjPng,
          tcList: [
            {
              tcName: "VIP会员",
              count: "48",
              countDesc: "",
              featureList: [
                {
                  name: "一键发送",
                  support: true,
                },
                {
                  name: "批量发送",
                  support: true,
                },
                {
                  name: "批量选择",
                  support: true,
                },
                {
                  name: "批量排序",
                  support: true,
                },
                {
                  name: "书签模式",
                  support: true,
                },
                {
                  name: "多色标签",
                  support: true,
                },
                {
                  name: "自定义热键",
                  support: true,
                },
                {
                  name: "短语储存量（无限）",
                  support: true,
                },
                {
                  name: "翻译功能（字符另行付费）",
                  support: true,
                },
                {
                  name: "图文储存、发送",
                  support: true,
                },
                {
                  name: "Excel导入导出",
                  support: true,
                },
                {
                  name: "7天数据云备份",
                  support: true,
                },
                {
                  name: "7天数据手动备份",
                  support: true,
                },
                {
                  name: "大图预览",
                  support: true,
                },
              ],
            }
          ],
          canTest: false,
        },
        {
          title: "永久会员",
          titleDesc: "永久使用所有功能",
          titleBg: hhPng,
          tcList: [
            {
              tcName: "VIP会员",
              count: "198",
              countDesc: "",
              featureList: [
              {
                  name: "一键发送",
                  support: true,
                },
                {
                  name: "批量发送",
                  support: true,
                },
                {
                  name: "批量选择",
                  support: true,
                },
                {
                  name: "批量排序",
                  support: true,
                },
                {
                  name: "书签模式",
                  support: true,
                },
                {
                  name: "多色标签",
                  support: true,
                },
                {
                  name: "自定义热键",
                  support: true,
                },
                {
                  name: "短语储存量（无限）",
                  support: true,
                },
                {
                  name: "翻译功能（字符另行付费）",
                  support: true,
                },
                {
                  name: "图文储存、发送",
                  support: true,
                },
                {
                  name: "Excel导入导出",
                  support: true,
                },
                {
                  name: "7天数据云备份",
                  support: true,
                },
                {
                  name: "7天数据手动备份",
                  support: true,
                },
                {
                  name: "大图预览",
                  support: true,
                },
              ],
            },
          ],
          canTest: false,
        },
      ],
    };
  },
  methods: {
    freeTest(){
      this.$emit("freeTest")
    }
  }
};
</script>
<style scoped>
.demand {
  background: url("../../assets/imgs/home/demand/demandBg.png");
  background-size: cover;
  background-repeat: repeat;
  padding: 5.625rem 0;
}
.moduleTitle {
  margin-bottom: 5rem;
}
.demandBox > div {
  width: calc((100% - 60px) / 3);
  border-radius: 0.75rem;
  overflow: hidden;
}
.demandBox > div:last-child {
  margin-right: 0;
}
.titleArea {
  padding: 1.625rem 0 0.875rem;
  text-align: center;
  color: #fff;
  background-repeat: no-repeat;
  background-size: cover;
}
.title {
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5rem;
}
.titleDesc {
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  font-size: 0.875rem;
  margin: 0.5rem 0;
}
.mainArea {
  padding: 0 1.875rem 0 2.5rem;
  background-color: #fff;
  min-height: 22.5rem;
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.mainArea > div {
  padding: 1.5rem 0;
}
.mainArea > div:first-child {
  border-bottom: 1px solid #e6e6e6;
}
.tcName {
  display: inline-block;
  border-radius: 1.375rem;
  padding: 0.5rem 0.9375rem;
  color: #000;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;
  background: #f6f6f6;
}
.countArea {
  margin: 1.625rem 0 1.75rem;
  color: #000;
}
.unit {
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1rem;
}
.count {
  font-size: 2.375rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1rem;
  margin-left: 0.125rem;
}
.countDesc {
  color: #9a9a9a;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1rem;
  margin-left: 1.25rem;
}
.mainArea .featureBox {
  margin-bottom: 0.8125rem;
}
.mainArea .featureBox:last-child {
  margin-bottom: 0;
}
.featureBox img {
  width: 1.375rem;
  height: 1.375rem;
  margin-right: 0.625rem;
}
.featureBox div {
  color: #333;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1rem; /* 131.25% */
}
.testBtn {
  margin-top: 0;
  border-radius: 1.75rem;
  padding: 0.75rem 1.75rem;
  background: linear-gradient(180deg, #5192fd 0%, #1d6ced 100%);
  color: #fff;
  font-style: normal;
  line-height: 1rem;
  display: inline-block;
  cursor: pointer;
}
@media (max-width: 768px) {
}
</style>